<template>
  <div>
    <div
      class="container-autocomplete"
      v-if="results !== null "
    >
      <div
        v-for="(item, index) in results"
        :key="index"
        class="autocomplete"
      >
        <a
          v-if="item.acf_if_video == true"
          @click.stop="openModalVideo(item.modal)"
          role="button"
          href="javascript:;"
        >
          <word-highlighter

            :query="query"
            :split-by-space="true"
            :highlight-class="'highlight'"
          >
            {{ item.title.rendered }}
          </word-highlighter>
        </a>
        <a
          v-if="item.acf_if_image == true"
          @click="openModalImg(item.modal)"
          role="button"
          href="javascript:;"
        >
          <word-highlighter

            :query="query"
            :split-by-space="true"
            :highlight-class="'highlight'"
          >
            {{ item.title.rendered }}
          </word-highlighter>
        </a>
        <a
          :href="item.acf_if_link ? item.modal : (item.is_document ? item.is_document : item.link)"
          v-if="item.title && item.acf_if_video == false && item.acf_if_image == false"
          :target="item.acf_if_link ? item.modal_target : (item.is_document ? '_blank' : '_self')"
        >

          <word-highlighter

            :query="query"
            :split-by-space="true"
            :highlight-class="'highlight'"
          >
            {{ item.title.rendered }}
          </word-highlighter>
        </a>
      </div>
      <a
        class="btn"
        href="#"
        target=""
        @click="$parent.selectResult"
        v-if="!noResu"
      >{{ textCta }}</a>
    </div>
    <modal-video-search
      v-if="activeModalVideo"
      @close-modal-video="closeModalVideo"
      :id-youtube="linkVideo"
    />
    <modal-img-search
      v-if="activeModalImg"
      @close-modal-img="closeModalImg"
      :images="item.modal"
    />
  </div>
</template>
<script>
import WordHighlighter from 'vue-word-highlighter';
import ModalVideoSearch from './ModalVideoSearch';
import ModalImgSearch from './ModalImgSearch';

export default {
  components: {
    WordHighlighter,
    ModalVideoSearch,
    ModalImgSearch,
  },
  props: {
    results: {
      type: [Object, Array],
      required: true,
    },
    query: {
      type: [String, Number],
      required: true,
      default: null,
    },
    textCta: {
      type: String,
      required: true,
    },
    noResu: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      activeModalVideo: false,
      activeModalImg: false,
      linkVideo: null,
      linkImage: null,
    }
  },
  methods: {
    openModalVideo(elem) {
      this.linkVideo = elem;
      this.activeModalVideo = true;
      document.body.classList.add('modal-is-open');
    },
    closeModalVideo() {
      this.activeModalVideo = false;
      document.body.classList.remove('modal-is-open');
    },
    openModalImg(elem) {
      this.linkImage = elem
      this.activeModalImg = true;
      document.body.classList.add('modal-is-open');
    },
    closeModalImg() {
      this.activeModalImg = false;
      document.body.classList.remove('modal-is-open');
    },
  },

}
</script>

<style lang="scss" scoped>

</style>
